import apiAction from "../ajax/service";
import {setEventExtras, setEventInfo, setEventsInfo , setEventAgreements } from "../features/rentSlice";
import { saveActionResultsToState } from "../features/analyticsSlice";




const loadEvents = async (
  dispatch,
  page = 1,
  limit = 25,
  pageData = {},
  eventFilters = {}
) => {
  if (pageData instanceof Set) {
    if (pageData.has(page)) return;
  } else {
    if (page in pageData) return;
  }

  var data = await apiAction(
    "events",
    {
      page,
      limit,
      filters: {
        select: {
          id: true,
          name: true,
          startDate:true,
          endDate:true,
          description: true,
        },
        ...eventFilters,
      },
    },
    "getAll",
    dispatch,
  );
  dispatch(setEventsInfo({data:data.data ,page:page, total:data.totalRecords, currentPage:data.currentPage}))
};
const loadEventInfo = async(
    dispatch ,
    id ,
    isSuite=false
) => {
    var data = await apiAction("events" , {id,isSuite} , "fetchRelated")
//     if (data.data.isMultiTenant){
//       dispatch(setEventAgreements({page:1,data:data.data.rentalAgreements,totalRecords:data.data.rentalAgreements?.[0]?._count.agreementItems
// }))
//     } else {
    dispatch(setEventAgreements({page:1,data:data.data.rentalAgreement?.agreementItems,totalRecords:data.data.rentalAgreement?._count?.agreementItems

    }))
  // }
    data.data.agreementId = data.data.rentalAgreement?.id
    data.data.status = data.data.rentalAgreement?.status
    delete data.data.rentalAgreement
    dispatch(setEventInfo(data.data))

}

const setExtras = async (
    dispatch ,
    id ,
    extrasJson
)=> {
   const response = await apiAction('events',{ id , extras:extrasJson } , 'update')

  dispatch(setEventExtras(response.extras))
}

const addRentalDefaultToEvent = async (dispatch , agreementInfo ) => {
  let action = 'add'
  // if(agreementInfo.agreementItemId){
  //   agreementInfo['id']=agreementInfo['agreementItemId']
  //   delete agreementInfo['agreementItemId']
  // }
  if(agreementInfo.agreementId){
    action = 'update'
    agreementInfo['id']=agreementInfo['agreementId']
    delete agreementInfo['agreementId']
  }
  const response =  await apiAction('forms',{modal : 'rentalAgreement',  ...agreementInfo} , action)
}

const mapRentalToEventSuite = async (dispatch , rentals , eventId , disconnect=false ) => {
  const response =  await apiAction('forms',{modal : 'Event', id:eventId, rentals , disconnect} , 'update_rental')
}
const mapTenantToEventSuite = async(dispatch , tenants , eventId) =>{
  const response =  await apiAction('forms',{modal : 'Event', id:eventId, tenant:tenants} , 'update_tenant')

}

const loadSuiteAnalytics = async (dispatch, id)=>{
  if (!id) return
  var data = await apiAction("stats", { id}, "persuite",dispatch);
  dispatch(saveActionResultsToState({action : "persuite", id: id , result:data }))
}

const mapAgreementsToEventSuite = async (dispatch ,eventId, agreements,tenantId) => {
  const response = await apiAction('forms',{modal : 'RentalAgreement', id:eventId, agreements , tenantId} , 'update_suite_agreement')

}

export {mapAgreementsToEventSuite,mapTenantToEventSuite,loadEvents,loadEventInfo,setExtras,addRentalDefaultToEvent,loadSuiteAnalytics,mapRentalToEventSuite}
